import React from 'react'
import { Modal, Form, Input, Select, DatePicker, Radio } from 'antd'
import moment from "moment"

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;

const CollectionCreateForm = Form.create()(
  class extends React.Component {
    render() {
      
      const { visible, onCancel, onCreate, form, selectedRange} = this.props;
      const { getFieldDecorator } = form;
      
      if (selectedRange) {
        var startDate = selectedRange.start;
        var endDate = selectedRange.end;
      } 
      
      return (
        <Modal
          visible={visible}
          title="Create a new event"
          okText="Create"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <FormItem label="Title" style={{ marginBottom: 0 }}>
              {getFieldDecorator('title', {
                rules: [{ required: true, message: 'Please input the title of the event!' }],
              })(
                <Input />
              )}
            </FormItem>
            <FormItem label="Description" style={{ marginBottom: 0 }}>
              {getFieldDecorator('description')(<Input type="textarea" />)}
            </FormItem>
            <FormItem label="Colour" style={{ marginBottom: 0 }}>
              {getFieldDecorator('color', {
                rules: [{ required: true, message: 'Please select a colour.' }],
                initialValue: 'Blue'
              })(
                <Select>
                  <Select.Option value='Red'>Red - Leave</Select.Option>
                  <Select.Option value='Blue'>Blue - Appointment</Select.Option>
                  <Select.Option value='Green'>Green - Training</Select.Option>
                  <Select.Option value='Yellow'>Yellow - Meetings</Select.Option>
                  <Select.Option value='Purple'>Purple - Public Holiday</Select.Option>
                  <Select.Option value='Orange'>Orange</Select.Option>
                </Select>
              )}
            </FormItem>
            <FormItem label="Date" style={{ marginBottom: 0 }}>
              {getFieldDecorator('range', {
                rules: [{ required: true, message: 'Please select a date.' }],
                initialValue: [moment(startDate), moment(endDate).add(1, 'seconds')]
              })(
                <RangePicker
                  showTime={{ format: 'HH:mm', defaultValue: [moment('00:00', 'HH:mm'), moment('00:01', 'HH:mm')] }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder={['Start date', 'End date']}
                  style={{ width: '100%' }}
                />
              )}
            </FormItem>
            <FormItem label="All Day?" style={{ marginBottom: 0 }}>
              {getFieldDecorator('allDay', {
                initialValue: true
              })(
                <RadioGroup>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </RadioGroup>
              )}
            </FormItem>
          </Form>
        </Modal>
      );
    }
  }
);

export default CollectionCreateForm